import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  cancelationTable: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: Theme.typography.base.regular,

    '& .divider-separator': {
      marginBottom: 24,
    },

    '& ul': {
      listStyleType: 'none',
      padding: 0,
      margin: 0,
      width: '100%',
    },

    '& p': {
      fontSize: Theme.typography.size[1],
    },

    '& li:nth-child(even)': {
      background: Theme.palette.gray[50],
    },

    '& .table-title': {
      fontSize: Theme.typography.size[2],
      color: Theme.palette.primary.main,
      fontFamily: Theme.typography.base.semiBold,
      display: 'flex',
      padding: '10px 15px',
      alignItems: 'center',

      [Theme.breakpoints.up('sm')]: {
        padding: '15px 20px',
      },

      '& span': {
        flex: 1,
        textAlign: 'right',
        [Theme.breakpoints.up('sm')]: {
          textAlign: 'start',
        },
      },

      '& span:first-child': {
        flex: 1,
        textAlign: 'left',
        paddingLeft: 34,
        [Theme.breakpoints.up('sm')]: {
          paddingLeft: 104,
        },
      },

      '& .flight-cost': {
        [Theme.breakpoints.only('md')]: {
          marginLeft: 35,
        },
        [Theme.breakpoints.up('lg')]: {
          marginLeft: 145,
        },
      },
    },

    '& .flight-cost': {
      display: 'none',

      [Theme.breakpoints.up('sm')]: {
        display: 'flex',
        flex: 1,
      },
    },

    '& .row-item': {
      display: 'flex',
      alignItems: 'center',
      padding: 15,

      [Theme.breakpoints.up('sm')]: {
        padding: 20,
      },

      '& svg': {
        transform: 'scale(1.11)',
      },

      '& .cancellation-check': {
        padding: 0,
        paddingRight: 10,
        [Theme.breakpoints.up('sm')]: {
          display: 'flex',
          paddingRight: 0,
        },
      },

      '& .guest-info': {
        display: 'flex',
        flexDirection: 'column',
        flex: 2,
        textTransform: 'capitalize',

        '& span': {
          fontSize: Theme.typography.size[0],
        },
        '& span:first-child': {
          fontFamily: Theme.typography.base.semiBold,
          fontSize: Theme.typography.size[1],
          marginBottom: 5,
        },
        [Theme.breakpoints.up('sm')]: {
          flex: 1.7,

          '& span:first-child': {
            marginLeft: 80,
            fontFamily: Theme.typography.base.regular,
            fontSize: Theme.typography.size[2],
            marginBottom: 0,
          },
          '& span:nth-child(2)': {
            display: 'none',
          },
        },

        [Theme.breakpoints.up('xl')]: {
          '& span:first-child': {
            fontSize: Theme.typography.size[3],
          },
        },
      },

      '& .flight-cost': {
        marginLeft: 0,
        fontSize: Theme.typography.size[2],
        [Theme.breakpoints.only('lg')]: {
          marginLeft: 80,
        },
        [Theme.breakpoints.only('xl')]: {
          fontSize: Theme.typography.size[3],
          marginLeft: 80,
        },
      },

      '& .price': {
        flex: 1,
        textAlign: 'right',
        fontSize: Theme.typography.size[1],

        [Theme.breakpoints.up('sm')]: {
          textAlign: 'left',
          fontSize: Theme.typography.size[2],
        },
        [Theme.breakpoints.up('xl')]: {
          fontSize: Theme.typography.size[3],
        },
      },
    },

    '& .row-item.summary-item': {
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: Theme.typography.size[1],
      color: Theme.palette.primary.main,
      fontFamily: Theme.typography.base.semiBold,
      [Theme.breakpoints.down('sm')]: {
        '& span:nth-child(2)': {
          width: '65%',
        },
      },
      [Theme.breakpoints.between('xs', 'sm')]: {
        '& span:nth-child(2)': {
          width: '60%',
        },
      },
      [Theme.breakpoints.up('sm')]: {
        fontSize: Theme.typography.size[3],
        '& span:first-child': {
          width: '41%',
        },
        '& span:last-child': {
          width: '32%',
        },
      },
      [Theme.breakpoints.up('md')]: {
        '& span:first-child': {
          width: '31%',
        },
        '& span:last-child': {
          width: '32%',
        },
      },

      [Theme.breakpoints.up('lg')]: {
        '& span:first-child': {
          width: '28%',
        },
        '& span:last-child': {
          width: '31%',
        },
      },

      [Theme.breakpoints.up('xl')]: {
        '& span:first-child': {
          width: '27%',
        },
        '& span:last-child': {
          width: '30.5%',
        },
      },
    },

    '& .summary-container': {
      alignSelf: 'flex-end',
      width: '100%',

      [Theme.breakpoints.only('md')]: {
        width: '52%',
      },

      [Theme.breakpoints.up('lg')]: {
        width: '48%',
      },

      '& p': {
        margin: 0,
        padding: 0,
      },

      '& .summary-title': {
        color: Theme.palette.primary.main,
        fontSize: Theme.typography.size[3],
        fontWeight: '600',
        lineHeight: '150%',
        marginBottom: '8px',
      },

      '& .summary-cost': {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 8,
        '& p': {
          color: Theme.palette.gray[750],
          fontSize: Theme.typography.size[1],
        },
      },
      '& .total-cost': {
        display: 'flex',
        justifyContent: 'space-between',
        '& p': {
          color: Theme.palette.primary.main,
          fontSize: Theme.typography.size[3],
          fontWeight: '600',
          lineHeight: '24px',
        },
      },
    },
  },
}));

export default useStyles;
